import {TimeUtils} from '@vdw/angular-component-library';
import {DateTime} from 'luxon';

export class ScheduleUnavailableDay {
  private _id: number;
  private _date: DateTime;

  public constructor(id: number, date: DateTime) {
    this._id = id;
    this._date = date;
  }

  public get id(): number {
    return this._id;
  }

  public get date(): DateTime {
    return this._date;
  }

  public static fromJSON(unavailableDayJSON: any): ScheduleUnavailableDay {
    return new ScheduleUnavailableDay(unavailableDayJSON.id, TimeUtils.convertToLocalDateTime(DateTime.fromISO(unavailableDayJSON.date)));
  }

  public toJSON(): JSON {
    return {id: this._id, date: TimeUtils.convertToUTCDateTime(this._date).toISO()} as any as JSON;
  }
}
